import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Redirect } from "react-router-dom";
import srcImg from "../../assets/img/modal/modal-nuevo-forzadores-nrf.jpg";
import nrfPresentation from "../../../public/videos/nrfPresentation.mp4"
import "./styles.scss";

// import CarouselModal from './CarouselModal.js';

const ModalPromos = (props) => {
    const { className, OpenModal } = props;

    const [modal, setModal] = useState(OpenModal);

    const toggle = () => setModal(!modal);

    function modalRedirect(e) {
        e.preventDefault();
        toggle();
        window.location.href = "/#/novedades/";
    }

    if (modal) setTimeout(toggle, 4000);

    const externalCloseBtn = (
        <button
            className="close text-white"
            style={{ position: "absolute", top: "15px", right: "15px" }}
            onClick={toggle}
        >
            &times;
        </button>
    );
    return (
        <div>
            <Modal
                centered
                isOpen={modal}
                toggle={toggle}
                className={`promo-modal modal-lg ${className ? className : ""}`}
                external={externalCloseBtn}
            >
                <ModalBody className="promo-modal-body">
                <a href="/#/productos/h7mn/PRODUCTOS/-lfdhimu5mg">
                    <img
                        src={srcImg}
                        alt="Promo"
                        className="promo-modal-image"
                    />
                </a>

                {/* <video className="promo-modal-image" autoPlay muted controls>
                    <source src={nrfPresentation}type="video/mp4"/>
                </video> */}
                </ModalBody>
            </Modal>
        </div>
    );
};

export default ModalPromos;



// WEBPACK FOOTER //
// ./src/components/ModalPromos/ModalPromos.js